import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[NoScrollbar]'
})
export class ScrollbarDirective {
    constructor(el: ElementRef) {
      const stylesheet = `
      ::-webkit-scrollbar {
          display: none;
          width: 0px
        }
        *{
          scrollbar-width: thin;
        }
      `;
  
      const styleElmt = el.nativeElement.shadowRoot.querySelector('style');

      if (styleElmt) {
        styleElmt.append(stylesheet);
      } else {
        const barStyle = document.createElement('style');
        barStyle.append(stylesheet);
        el.nativeElement.shadowRoot.appendChild(barStyle);
      }
    }
}
